import { DeleteOutlined } from "@ant-design/icons";
import { Button, Card, Space, Typography } from "antd";

const { Text } = Typography;

/**
 *
 * Component renders a list of editable templates
 */
const BasicRender = ({ datasetTemplate, onRemove, isEditable }) => {
  const cardActions = [];
  cardActions.push(
    <Button
      key="delete"
      name="Delete"
      type="primary"
      icon={<DeleteOutlined />}
      onClick={() => {
        onRemove(datasetTemplate.layout_index);
      }}
      disabled={!isEditable}
    />
  );

  return (
    <Card size="small" title={datasetTemplate.name} extra={cardActions}>
      <Space orientation="vertical" size="middle">
        <Text>{datasetTemplate.description}</Text>
      </Space>
    </Card>
  );
};

export default BasicRender;
